import React from "react";

// Components
import FormValidation from "pages/ticketing/components/FormValidation";

const UserFormModal = ({
  handleOpenUploadForm,
  handleInputChange,
  userForm,
  show,
  t,
}) => {
  if (!show) return null;

  return (
    <div className="text-justify">
      <h3 className="mb-6 text-xl font-semibold leading-snug">
        Turn your ESG vision into recognition. Submit your story today!
      </h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold">
            Company Name<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="companyName"
            placeholder="Company’s Name"
            className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#93C047] focus:outline-none"
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            value={userForm.companyName}
          />
          <FormValidation
            value={userForm.companyName}
            showError={!userForm.validCompanyName}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">
            Contact Person Name<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="contactPersonName"
            placeholder="Your Name"
            className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#93C047] focus:outline-none"
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            value={userForm.contactPersonName}
          />
          <FormValidation
            value={userForm.contactPersonName}
            showError={!userForm.validContactPersonName}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">
            Whatsapp Number<span className="text-red-500">*</span>
          </label>
          <div className="bg-white flex rounded-md p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-within:ring-2 focus-within:ring-inset focus-within:ring-[#93C047] sm:text-sm sm:leading-6 w-full mt-1">
            <span>+</span>(
            <input
              type="number"
              name="phoneCode"
              className="w-8 text-sm font-bold text-center outline-none select-none"
              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
              value={userForm.phoneCode}
            />
            <span>)</span>
            <input
              name="phoneNumber"
              placeholder={t("contactFormPlaceholder7")}
              type="number"
              min="0"
              className="block w-full pl-2 text-sm text-gray-900 border-0 outline-none placeholder:text-gray-400 sm:leading-6"
              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
              value={userForm.phoneNumber}
            />
          </div>
          <FormValidation
            value={userForm.phoneCode && userForm.phoneNumber}
            showError={!userForm.validPhoneCode || !userForm.validPhoneNumber}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">
            Email Address<span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="emailAddress"
            placeholder="company@email.com"
            className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#93C047] focus:outline-none"
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            value={userForm.emailAddress}
          />
          <FormValidation
            value={userForm.emailAddress}
            showError={
              !userForm.validEmailAddress || !userForm.validEmailFormat
            }
            errorMsg={
              userForm.validEmailFormat ? "Must be valid email format." : ""
            }
          />
        </div>

        <div className="flex flex-col justify-end gap-3 pt-2 sm:flex-row">
          <div
            className="px-4 py-2 rounded-md bg-[#F58220] text-white hover:bg-[#D67E32] transition text-sm font-medium cursor-pointer text-center"
            onClick={() =>
              handleOpenUploadForm({
                firstForm: true,
                secondForm: false,
                downloadForm: false,
                paymentEvidenceForm: false,
              })
            }
          >
            Next
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFormModal;
